import { FrameRectangle } from '../../../../../common/components/cart-loader/frame-rectangle/FrameRectangle';
import styles from './ListSummaryLoader.module.scss';
import { ListSummaryLoaderMobile } from './list-summary-loader-mobile/ListSummaryLoaderMobile';

export const ListSummaryLoader = ({ className = '' }: { className?: string }) => (
  <div className={`${styles['my-list-items-loader-summary']} ${className}`}>
    <div className={styles['my-list-items-loader-summary-wrapper']}>
      <FrameRectangle className={styles['my-list-items-loader-summary-wrapper-top-box']} />
      <div className={styles['my-list-items-loader-summary-wrapper-middle']}>
        <div className={styles['my-list-items-loader-summary-wrapper-middle-left']}>
          <FrameRectangle className={styles['my-list-items-loader-summary-wrapper-middle-left-box-1']} />
          <FrameRectangle className={styles['my-list-items-loader-summary-wrapper-middle-left-box-2']} />
        </div>
        <div className={styles['my-list-items-loader-summary-wrapper-middle-right']}>
          <FrameRectangle className={styles['my-list-items-loader-summary-wrapper-middle-right-box-1']} />
          <FrameRectangle className={styles['my-list-items-loader-summary-wrapper-middle-right-box-2']} />
        </div>
      </div>
      <FrameRectangle className={styles['my-list-items-loader-summary-wrapper-bottom-box']} />
    </div>

    <div className={`${styles['my-list-items-loader-summary-wrapper-tablet']} sticky-bottom-bar`}>
      <div className={styles['my-list-items-loader-summary-wrapper-tablet-left']}>
        <FrameRectangle className={styles['my-list-items-loader-summary-wrapper-tablet-left-box']} />
        <FrameRectangle className={styles['my-list-items-loader-summary-wrapper-tablet-left-box']} />
      </div>
      <FrameRectangle className={styles['my-list-items-loader-summary-wrapper-tablet-right-box']} />
    </div>
    <ListSummaryLoaderMobile
      className={`${styles['my-list-items-loader-summary-wrapper-mobile-view']} sticky-bottom-bar`}
    />
  </div>
);
